<template>
    <div class="container">
        <div class="toolbar shadow-sm">
            <img src="@/assets/icons/ConfigurationIcon.png" />
            <span class="title">{{ $t("admin.system.title") }}</span>
        </div>

        <div class="overview-container shadow-sm">
            <router-link to="/system/mapDeploymentTool">{{ $t("admin.system.map_deployment_tool.title") }}</router-link>
        </div>
        <div class="overview-container shadow-sm">
            <router-link to="/system/publisherConfigurationTool">{{ $t("admin.system.publisher_configuration_tool.title") }}</router-link>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    margin: 0px;
    margin-bottom: 16px;
    width: 100%;
    max-width: none;
    text-align: left;
}

.toolbar {
    background-color: #ffffff;
    margin-bottom: 8px;
    padding: 8px;
    padding-left: 24px;
    text-align: left;
    width: 100%;
}

.toolbar img {
    margin-right: 16px;
    width: 50px;
}

.toolbar .title {
    display: inline-block;
    font-size: 16px;
    font-weight: bold;
    margin-right: 36px;
    max-width: 250px;
}

.toolbar button {
    margin: 0px 4px;
}

.overview-container {
    background-color: #ffffff;
    margin: 0 auto;
    overflow: scroll;
    padding: 24px;
    text-align: left;
    width: 100%;
    height: auto;
}
</style>